module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_9016.e6f0dbec.png";